// LIST
export const FETCH_SLICK_CARE_PROFILES =
  "app/Location/FETCH_SLICK_CARE_PROFILES";
export const FETCH_SLICK_CARE_PROFILES_SUCCESS =
  "app/Location/FETCH_SLICK_CARE_PROFILES_SUCCESS";
export const FETCH_SLICK_CARE_PROFILES_FAILURE =
  "app/Location/FETCH_SLICK_CARE_PROFILES_FAILURE";
// LIST
export const SEARCH_SLICK_CARE_PROFILES =
  "app/Location/SEARCH_SLICK_CARE_PROFILES";
export const SEARCH_SLICK_CARE_PROFILES_SUCCESS =
  "app/Location/SEARCH_SLICK_CARE_PROFILES_SUCCESS";
export const SEARCH_SLICK_CARE_PROFILES_FAILURE =
  "app/Location/SEARCH_SLICK_CARE_PROFILES_FAILURE";
// GET VIEW DATA
export const GET_VIEW_DATA = "app/Location/GET_VIEW_DATA";
export const GET_VIEW_DATA_SUCCESS = "app/Location/GET_VIEW_DATA_SUCCESS";
export const GET_VIEW_DATA_FAILURE = "app/Location/GET_VIEW_DATA_FAILURE";
// ADD
export const ADD_SLICK_CARE_PROFILES = "app/Location/ADD_SLICK_CARE_PROFILES";
export const ADD_SLICK_CARE_PROFILES_SUCCESS =
  "app/Location/ADD_SLICK_CARE_PROFILES_SUCCESS";
export const ADD_SLICK_CARE_PROFILES_FAILURE =
  "app/Location/ADD_SLICK_CARE_PROFILES_FAILURE";
// EDIT
export const EDIT_SLICK_CARE_PROFILES = "app/Location/EDIT_SLICK_CARE_PROFILES";
export const EDIT_SLICK_CARE_PROFILES_SUCCESS =
  "app/Location/EDIT_SLICK_CARE_PROFILES_SUCCESS";
export const EDIT_SLICK_CARE_PROFILES_FAILURE =
  "app/Location/EDIT_SLICK_CARE_PROFILES_FAILURE";
// DELETE
export const DELETE_SLICK_CARE_PROFILES =
  "app/Location/DELETE_SLICK_CARE_PROFILES";
export const DELETE_SLICK_CARE_PROFILES_SUCCESS =
  "app/Location/DELETE_SLICK_CARE_PROFILES_SUCCESS";
export const DELETE_SLICK_CARE_PROFILES_FAILURE =
  "app/Location/DELETE_SLICK_CARE_PROFILES_FAILURE";

export const OPEN_WEBSITE_MODAL = "app/Location/OPEN_WEBSITE_MODAL";
export const CLOSE_WEBSITE_MODAL = "app/Location/CLOSE_WEBSITE_MODAL";

export const OPEN_ROOM_ADD_MODAL = "app/Location/OPEN_ROOM_ADD_MODAL";
export const CLOSE_ROOM_ADD_MODAL = "app/Location/CLOSE_ROOM_ADD_MODAL";

export const OPEN_VIEW_ROOMS_MODAL = "app/Location/OPEN_VIEW_ROOMS_MODAL";
export const CLOSE_VIEW_ROOMS_MODAL = "app/Location/CLOSE_VIEW_ROOMS_MODAL";

// ADD
export const ADD_ROOM = "app/Location/ADD_ROOM";
export const ADD_ROOM_SUCCESS = "app/Location/ADD_ROOM_SUCCESS";
export const ADD_ROOM_FAILURE = "app/Location/ADD_ROOM_FAILURE";
// LIST
export const FETCH_ROOMS = "app/Location/FETCH_ROOMS";
export const FETCH_ROOMS_SUCCESS = "app/Location/FETCH_ROOMS_SUCCESS";
export const FETCH_ROOMS_FAILURE = "app/Location/FETCH_ROOMS_FAILURE";

export const FETCH_ALL_LOCATION = "app/Location/FETCH_ALL_LOCATION";
export const FETCH_ALL_LOCATION_SUCCESS =
  "app/Location/FETCH_ALL_LOCATION_SUCCESS";
export const FETCH_ALL_LOCATION_FAILURE =
  "app/Location/FETCH_ALL_LOCATION_FAILURE";

// CARE ROOMS
export const FETCH_ALL_ROOMS = "app/Location/FETCH_ALL_ROOMS";
export const FETCH_ALL_ROOMS_SUCCESS = "app/Location/FETCH_ALL_ROOMS_SUCCESS";
export const FETCH_ALL_ROOMS_FAILURE = "app/Location/FETCH_ALL_ROOMS_FAILURE";

export const GET_CARE_ROOM_DATA = "app/Location/GET_CARE_ROOM_DATA";
export const GET_CARE_ROOM_DATA_SUCCESS =
  "app/Location/GET_CARE_ROOM_DATA_SUCCESS";
export const GET_CARE_ROOM_DATA_FAILURE =
  "app/Location/GET_CARE_ROOM_DATA_FAILURE";

export const DELETE_CARE_ROOM = "app/Location/DELETE_CARE_ROOM";
export const DELETE_CARE_ROOM_SUCCESS = "app/Location/DELETE_CARE_ROOM_SUCCESS";
export const DELETE_CARE_ROOM_FAILURE = "app/Location/DELETE_CARE_ROOM_FAILURE";

export const EDIT_CARE_ROOM = "app/Location/EDIT_CARE_ROOM";
export const EDIT_CARE_ROOM_SUCCESS = "app/Location/EDIT_CARE_ROOM_SUCCESS";
export const EDIT_CARE_ROOM_FAILURE = "app/Location/EDIT_CARE_ROOM_FAILURE";

export const OPEN_INVITE_MODAL = "app/Location/OPEN_INVITE_MODAL";
export const CLOSE_INVITE_MODAL = "app/Location/CLOSE_INVITE_MODAL";

export const INVITE_STAFF = "app/Location/INVITE_STAFF";
export const INVITE_STAFF_SUCCESS = "app/Location/INVITE_STAFF_SUCCESS";
export const INVITE_STAFF_FAILURE = "app/Location/INVITE_STAFF_FAILURE";

export const OPEN_COMPANY_MODAL = "app/Location/OPEN_COMPANY_MODAL";
export const CLOSE_COMPANY_MODAL = "app/Location/CLOSE_COMPANY_MODAL";

export const SEARCH_COMPANY = "app/Location/SEARCH_COMPANY";
export const SEARCH_COMPANY_SUCCESS = "app/Location/SEARCH_COMPANY_SUCCESS";
export const SEARCH_COMPANY_FAILURE = "app/Location/SEARCH_COMPANY_FAILURE";

export const CHANGE_COMPANY = "app/Location/CHANGE_COMPANY";
export const CHANGE_COMPANY_SUCCESS = "app/Location/CHANGE_COMPANY_SUCCESS";
export const CHANGE_COMPANY_FAILURE = "app/Location/CHANGE_COMPANY_FAILURE";
